import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=62681ca4"
import script from "./TrainingDetail.vue?vue&type=script&lang=js"
export * from "./TrainingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports